export default __webpack_public_path__ + "static/media/travel.09745527.jpg";